module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-4.e4c0aca1.jpg";